import styled from 'styled-components/macro';

import { Flex } from 'components/styled/Flex';

export const MobileWrapper = styled(Flex)<{ display?: string }>`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: ${({ display }) => (display ? display : 'flex')};
  }
`;
